export default __webpack_public_path__ + "static/media/img-5.19bd9155.png";